/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { PDFDocument } from "pdf-lib";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { CircularProgress } from "@material-ui/core";
import { ENV_DECLARONS, isBrandActive } from "src/config/environment.config";
import { useQuery } from "@tanstack/react-query";
import { ProcurationProvider, ProcurationContextType } from "src/Contexts/ProcurationContext";
import mandataireSign from "src/Assets/Images/sign.png";
import Teachr from "src/Objects/models/Teachr";
import { resolveProcurationCode } from "src/Helpers/ProcurationType";
import ImageRepository from "src/Repositories/ImageRepository";
import TeachrRepository from "src/Repositories/TeachrRepository";
import { userTeachrSetAccountAction } from "src/Redux/Actions/UserActions";
import Sponsorship from "src/Objects/models/Sponsorship";
import { PutSponsorship } from "src/Objects/interfaces/AppInterface";
import { putSponsorship } from "src/Redux/Actions/SponsorshipActions";
import { AppDispatch } from "src/Redux/store";
import useTailwindBrand from "src/Theme/useTailwindBrand";
import LayoutApp from "src/Components/LayoutApp";
import IndexApp from "src/Components/IndexApp";
import AddressRepository from "src/Repositories/AddressRepository";
import { Address } from "src/Objects/models/Address";
import StepperProcuration from "src/Components/StepperProcuration";
import FirstProcuration from "./CompletProfil/ProcurationAe&Sap/FirstProcuration";
import SecondProcuration from "./CompletProfil/ProcurationAe&Sap/SecondProcuration";
import FirstPartAe from "./CompletProfil/ProcurationAe&Sap/Ae&Sap/FirstPartAe";
import SecondPartAe from "./CompletProfil/ProcurationAe&Sap/Ae&Sap/SecondPartAe";
import ThirdPartAe from "./CompletProfil/ProcurationAe&Sap/Ae&Sap/ThirdPartAe";
import FourthPartAe from "./CompletProfil/ProcurationAe&Sap/Ae&Sap/FourthPartAe";
import FifthPartAe from "./CompletProfil/ProcurationAe&Sap/Ae&Sap/FifthPartAe";
import SixthPartAe from "./CompletProfil/ProcurationAe&Sap/Ae&Sap/SixthPartAe";
import ThirdProcuration from "./CompletProfil/ProcurationAe&Sap/ThirdProcuration";
import LastProcuration from "./CompletProfil/ProcurationAe&Sap/LastProcuration";
import { SETTINGS_NAV_INDEX } from "../../Components/AppBar/AppBarConfigs";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const currentPageDocument = (step: number) => {
  switch (step) {
    case 1:
      return 1
    case 2:
      return 2
    case 3:
    case 4:
      return 3
    case 5:
    case 6:
      return 4
    case 7:
      return 5
    case 7.5:
      return 6
    default:
      return 1
  }
}
const renderCurrentStep = (step: number): number => {
  switch (step) {
    case 0:
    case 1:
      return 0;
    case 2:
      return 1;
    case 3:
    case 4:
    case 5:
    case 6:
      return 2;
    case 7:
      return 3;
    case 8:
    case 9:
      return 4;
    default:
      return 0;
  }
}
const currentProcurationPdf = () => {
    if (isBrandActive(ENV_DECLARONS)) {
      return `${process.env.PUBLIC_URL}/Pouvoir_procuration_creation_auto-entreprise-TeachR_VDEF_declarons.pdf`
    }
  return `${process.env.PUBLIC_URL}/Pouvoir_procuration_creation_auto-entreprise-TeachR_VDEF.pdf`
}
const IndexProcuration = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { classes } = useTailwindBrand()
  const typeOfProcuration = useSelector((state: any) => state.user.currentProcuration)
  const generalTeachr = useSelector((state: any) => state.user.currentUser);
  const generalProcurationAe = useSelector((state: any) => state.procurationAe)
  const teachr: Teachr = generalTeachr?.teachr
  const stepProcuration = resolveProcurationCode(teachr?.procuration, typeOfProcuration)
  const generalProcuration = generalProcurationAe
  const previousPdfUrlRef = useRef<string | null>(null);
  const updateTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const pdfKeyRef = useRef(0);
  const [address, setAddress] = useState<Address>();
  const [state, setState] = useState({
    file: undefined as any,
    pdfFile: currentProcurationPdf() as any,
    isUpdatingPdf: false,
    numPages: null as any,
    currentStep: generalProcuration?.step ?? 0,
    page: currentPageDocument(generalProcuration?.step),
    loading: false,
    showDoc: false,
    windowWidth: window.innerWidth - 35,
  });

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setState(prev => ({ ...prev, numPages }));
  }
  const goToNextPage = () => {
    if (state.numPages && state.page < state.numPages) {
      setState(prev => ({ ...prev, page: prev.page + 1 }));
    }
  };
  const goToPrevPage = () => {
    if (state.page > 1) {
      setState(prev => ({ ...prev, page: prev.page - 1 }));
    }
  };

  useEffect(() => {
    const handleResize = () => setState(prev => ({ ...prev, windowWidth: window.innerWidth - 35 }));
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const { data: pdfDoc } = useQuery({
    queryKey: ['todos', state.pdfFile],
    queryFn: async () => {
      const response = await fetch(state.pdfFile);
      const arrayBuffer = await response.arrayBuffer();
      const pdfDocument = await PDFDocument.load(arrayBuffer);
      return pdfDocument;
    },
  })

  const updatePdfPreview = useCallback(async () => {
    setState(prev => ({ ...prev, isUpdatingPdf: true }));
    try {
      if (pdfDoc) {
        const pdfBytes = await pdfDoc.save();
        const pdfBlob = new Blob([pdfBytes as BlobPart], { type: "application/pdf" });

        if (previousPdfUrlRef.current && previousPdfUrlRef.current.startsWith('blob:')) {
          URL.revokeObjectURL(previousPdfUrlRef.current);
        }
        const pdfUrl = URL.createObjectURL(pdfBlob);
        previousPdfUrlRef.current = pdfUrl;
        pdfKeyRef.current += 1;
        setState(prev => ({
          ...prev,
          file: pdfBytes,
          pdfFile: pdfUrl,
          isUpdatingPdf: false
        }));
        setTimeout(() => {
          setState(prev => ({ ...prev, isUpdatingPdf: false }));
        }, 400);
      }
    } catch (error) {
      console.error('Erreur lors de la régénération du PDF:', error);
      setState(prev => ({ ...prev, isUpdatingPdf: false }));
    }
  }, [pdfDoc]);
  const triggerPdfUpdate = useCallback(() => {
    if (updateTimeoutRef.current) {
      clearTimeout(updateTimeoutRef.current);
    }
    updateTimeoutRef.current = setTimeout(() => {
      updatePdfPreview();
    }, 800);
  }, [updatePdfPreview]);
  // useEffect(() => {
  //   updatePdfPreview();
  // }, [pdfDoc, updatePdfPreview]);

  const nextStep = useCallback(async (secondSave: number) => {
    if (state.currentStep === 7 && state.page === 5) {
      setState(prev => ({
        ...prev,
        page: currentPageDocument(7.5),
        currentStep: 7
      }));
    } else {
      setState(prev => ({
        ...prev,
        currentStep: secondSave,
        page: currentPageDocument(secondSave)
      }));
    }
  }, [state.currentStep, state.page]);
  const prevStep = useCallback(() => {
    const newStep = Math.max(0, state.currentStep - 1);

    setState(prev => ({
      ...prev,
      currentStep: newStep,
      page: currentPageDocument(newStep)
    }));

    const payload = generalProcuration
      ? {
        ...JSON.parse(JSON.stringify(generalProcuration)),
        step: newStep
      }
      : {
        step: newStep
      };
    dispatch({ type: 'SET_AE_INFO', payload });
  }, [state.currentStep, generalProcuration, dispatch]);
  const setSignature = useCallback(async (signUrl: string) => {
    if (pdfDoc) {
      const pages = pdfDoc.getPages();
      const currentPage = pages[0];
      const { width } = currentPage.getSize();

      if (signUrl) {
        // Le champ date de signature (text_8ixqv) n'existe pas dans toutes les
        // variantes du document (ex. declarons) : on l'ignore s'il est absent.
        try {
          const dateField = pdfDoc.getForm().getTextField("text_8ixqv");
          dateField.setText(moment().format("L"));
        } catch {
          // champ absent dans ce document, on continue
        }
        const imageBytes1 = await fetch(signUrl).then((res) =>
          res.arrayBuffer()
        );
        const image1 = await pdfDoc.embedPng(imageBytes1);
        const imageBytes2 = await fetch(mandataireSign).then((res) =>
          res.arrayBuffer()
        );
        const image2 = await pdfDoc.embedPng(imageBytes2);
        let imageWidth = 100;
        let imageHeight = 30;
        currentPage.drawImage(image1, {
          x: imageWidth + 20,
          y: 90,
          width: imageWidth,
          height: imageHeight,
        });
        imageWidth = 230;
        imageHeight = 40;
        currentPage.drawImage(image2, {
          x: width - imageWidth - 10,
          y: 80,
          width: imageWidth,
          height: imageHeight,
        });
      }
    }
  }, [pdfDoc]);
  const setSignatureText = useCallback(async (signText: string) => {
    if (pdfDoc) {
      const pages = pdfDoc.getPages();
      const currentPage = pages[0];

      if (signText) {
        const imageBytes = await fetch(signText).then((res) =>
          res.arrayBuffer()
        );
        const image = await pdfDoc.embedPng(imageBytes);
        const imageWidth = 100;
        const imageHeight = 20;
        currentPage.drawImage(image, {
          x: 10,
          y: imageWidth,
          width: imageWidth,
          height: imageHeight,
        });
      }
    }
  }, [pdfDoc]);

  const handleCreateAddress = useCallback(async (): Promise<Address | null> => {
    const addressObj = generalProcuration?.secondProc?.addressObj ? generalProcuration?.secondProc?.addressObj : generalProcuration?.first?.addressObj;
    if (!addressObj) {
      console.warn('Aucune adresse renseignée (addressObj manquant).');
      return null;
    }
    try {
      const addressResponse = await AddressRepository.createAddress(addressObj);
      setAddress(addressResponse);
      return addressResponse;
    } catch (error) {
      console.warn('Erreur lors de la création de l\'adresse:', error);
      return null;
    }
  }, [generalProcuration?.secondProc?.addressObj, generalProcuration?.first?.addressObj]);

  const setProofIsAe = useCallback(async () => {
    setState(prev => ({ ...prev, loading: true }));
    const createdAddress = await handleCreateAddress();
    const firstName = generalProcuration?.secondProc?.firstName ? generalProcuration?.secondProc?.firstName : generalProcuration?.first?.firstName
    const lastName = generalProcuration?.secondProc?.lastName ? generalProcuration?.secondProc?.lastName : generalProcuration?.first?.lastName
    const birthDate = generalProcuration?.secondProc?.birthDate ? generalProcuration?.secondProc?.birthDate : generalProcuration?.first?.birthDate

    const label = 'proof-is-ae'
    if (state.file) {
      ImageRepository.createImage(new File([state.file], label, { type: "application/pdf" })).then((response) => {
        const updatedTeachr = { ...teachr };
        if (updatedTeachr.proofIdentity) {
          updatedTeachr.proofIdentity = teachr.proofIdentity['@id']
        }
        if (updatedTeachr.proofIdentity2) {
          updatedTeachr.proofIdentity2 = teachr.proofIdentity2['@id']
        }
        if (updatedTeachr.proofSignSap) {
          updatedTeachr.proofSignSap = teachr.proofSignSap['@id']
        }
        if (updatedTeachr && updatedTeachr.proofMandat) {
          updatedTeachr.proofMandat = teachr.proofMandat['@id']
        }
        updatedTeachr.proofIsAE = response["@id"];
        if (createdAddress?.['@id']) {
          updatedTeachr.address = createdAddress['@id']
        } else if (address?.['@id']) {
          updatedTeachr.address = address['@id']
        }
        if (firstName) {
          updatedTeachr.firstName = firstName
        }
        if (lastName) {
          updatedTeachr.lastName = lastName
        }
        if (birthDate) {
          updatedTeachr.birthday = birthDate
        }
        if (generalProcuration?.secondProc?.nationality) {
          updatedTeachr.isBornFrance = generalProcuration?.secondProc?.nationality === 73 ? true : false
        }
        if (generalProcuration?.secondProc?.gender) {
          updatedTeachr.sex = generalProcuration?.secondProc?.gender === 1 ? "WOMAN" : "MAN"
        }
        if (generalProcuration?.secondProc?.phone) {
          updatedTeachr.phone = generalProcuration?.secondProc?.phone
        }
        if (generalProcuration?.fourthProc?.socialSecurityNumber) {
          updatedTeachr.NNI = generalProcuration?.fourthProc?.socialSecurityNumber
        }
        if (generalProcuration?.first?.siret) {
          updatedTeachr.RCS = generalProcuration?.first?.siret
        }

        TeachrRepository.updateTeachr(updatedTeachr).then((teachrResponse) => {
          const serializedTeachr = JSON.parse(JSON.stringify(teachrResponse));
          dispatch(userTeachrSetAccountAction(serializedTeachr));
          dispatch({ type: 'SET_TEACHR_INFO', payload: { teachr: serializedTeachr } })
          if (teachrResponse && teachrResponse?.sponsorship) {
            const sponsorship = new Sponsorship(teachrResponse?.sponsorship)
            const handleNext = () => { }
            sponsorship.statut = "OK_PROC_AE"
            const data: PutSponsorship = { teachr, sponsorship, setLoad: (value: boolean) => setState(prev => ({ ...prev, loading: value })), handleNext }
            dispatch(putSponsorship(data))
          }
          nextStep(9)
          setState(prev => ({ ...prev, loading: false }));
        }).catch((error) => {
          console.warn(error);
          setState(prev => ({ ...prev, loading: false }));
        })
      })
        .catch((error) => {
          console.warn(error)
          setState(prev => ({ ...prev, loading: false }));
        }).finally(() => {
          setState(prev => ({ ...prev, loading: false }));
        })
    } else {
      setState(prev => ({ ...prev, loading: false }));
    }
  }, [state.file, teachr, address, dispatch, nextStep, generalProcuration, handleCreateAddress])

  const setPage = useCallback((page: number | ((prev: number) => number)) => {
    setState(prev => ({
      ...prev,
      page: typeof page === 'function' ? page(prev.page) : page
    }));
  }, []);

  const contextValue: ProcurationContextType = useMemo(() => ({
    prevStep,
    nextStep,
    setPage,
    currentStep: state.currentStep,
    teachr,
    pdfDoc,
    generalProcuration,
    triggerPdfUpdate: triggerPdfUpdate,
    setSignature,
    setSignatureText,
    dispatch,
    setProofIsAe,
    typeOfProcuration: stepProcuration,
    file: state.file,
    loading: state.loading
  }), [prevStep, nextStep, setPage, state.currentStep, state.file, state.loading, teachr, pdfDoc, generalProcuration, triggerPdfUpdate, setSignature, setSignatureText, dispatch, setProofIsAe, stepProcuration]);

  const renderScreenMobile = () => {
    if (state.showDoc) {
      return (<div className="mb-6 lg:hidden">
        <div className="rounded-lg border border-gray-200 overflow-hidden shadow-sm">
          <Document
            error='Impossible de charger le document.'
            file={state.pdfFile}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            <Page
              pageNumber={state.page}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              width={state.windowWidth}
            />
          </Document>
        </div>
      </div>)
    }
    return (
      <div className="mb-6 lg:hidden">
        <button
          onClick={() => setState(prev => ({ ...prev, showDoc: !prev.showDoc }))}
          className={`w-full flex items-center justify-between p-4 rounded-lg border-2 transition-all duration-200 ${state.showDoc
            ? `${classes.primaryBorder} bg-blue-50`
            : 'border-gray-200 hover:border-gray-300'
            }`}
        >
          <span className={`font-semibold ${state.showDoc ? classes.primaryText : 'text-gray-700'}`}>
            {state.showDoc ? 'Masquer le document' : 'Voir le document'}
          </span>
          <svg
            className={`w-5 h-5 transition-transform duration-200 ${state.showDoc ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>
    )
  }
  useEffect(() => {
    if (state.currentStep === 0 && teachr?.proofIsAE) {
      nextStep(9);
    }
  }, [state.currentStep, teachr?.proofIsAE, nextStep]);

  const renderScreenDesktop = () => {
    switch (state.currentStep) {
      case 0:
        return <FirstProcuration callBack={nextStep} />;
      case 1:
        return <FirstPartAe />;
      case 2:
        return <SecondProcuration />;
      case 3:
        return <SecondPartAe />;
      case 4:
        return <ThirdPartAe />;
      case 5:
        return <FourthPartAe />;
      case 6:
        return <FifthPartAe />;
      case 7:
        return <SixthPartAe />;
      case 8:
        return <ThirdProcuration />;
      case 9:
        return <LastProcuration prevStep={prevStep} />;
      default:
        return null;
    }
  }


  return (
    <IndexApp index={SETTINGS_NAV_INDEX} component={
      <LayoutApp>
        <ProcurationProvider value={contextValue}>
          <div className="min-h-screen bg-white p-2">
            <StepperProcuration currentStep={renderCurrentStep(state.currentStep)} type="procuration-ae" />
            <div className={`mx-auto px-4 py-8 border border-gray-500/50 rounded-xl ${classes.background} inset-shadow-xl inset-shadow-indigo-500/50 `}>
              {state.loading && (
                <div className="mb-6 flex items-center gap-3 p-4 bg-blue-50 rounded-lg border border-blue-100 shadow-sm">
                  <div className="animate-spin">
                    <svg className="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </div>
                  <span className="text-blue-700 font-medium text-sm">Enregistrement en cours...</span>
                </div>
              )}

              {/* Mobile PDF Toggle */}
              {state.currentStep !== 0 && renderScreenMobile()}

              {/* Main Content Grid */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {state.currentStep !== 0 && (
                  <div className="hidden lg:block">
                    <div className="sticky top-24">
                      <div className={`rounded-lg border border-gray-200  overflow-hidden shadow-sm bg-white`}>
                        <div className="p-3 bg-gray-50 border-b border-gray-200 flex items-center justify-between">
                          <span className="text-sm font-medium text-gray-700">Aperçu du document</span>

                          <div className="flex items-center gap-2">
                            <button
                              onClick={goToPrevPage}
                              disabled={state.page <= 1}
                              className={`p-1 rounded transition-colors ${state.page <= 1
                                ? 'text-gray-300 cursor-not-allowed'
                                : 'text-gray-600 hover:bg-gray-200 hover:text-gray-900'
                                }`}
                              aria-label="Page précédente"
                            >
                              <ChevronLeftIcon />
                            </button>
                            <span className="text-xs text-gray-500 min-w-[80px] text-center">
                              Page {state.page} / {state.numPages || '...'}
                            </span>
                            <button
                              onClick={goToNextPage}
                              disabled={!state.numPages || state.page >= state.numPages}
                              className={`p-1 rounded transition-colors ${!state.numPages || state.page >= state.numPages
                                ? 'text-gray-300 cursor-not-allowed'
                                : 'text-gray-600 hover:bg-gray-200 hover:text-gray-900'
                                }`}
                              aria-label="Page suivante"
                            >
                              <ChevronRightIcon />
                            </button>
                          </div>
                        </div>
                        <div className={`p-4 bg-gray-200 flex items-center justify-center relative`}>
                          {state.isUpdatingPdf && (
                            <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10 rounded">
                              <CircularProgress />
                            </div>
                          )}
                          <Document
                            key={pdfKeyRef.current}
                            error='Impossible de charger le document.'
                            file={state.pdfFile}
                            onLoadSuccess={onDocumentLoadSuccess}
                            loading={<CircularProgress />}
                          >
                            <Page
                              pageNumber={state.page}
                              renderTextLayer={false}
                              renderAnnotationLayer={false}
                            // className="shadow-lg transition-opacity duration-200"
                            />
                          </Document>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Form Content */}
                <div className={state.currentStep !== 0 ? 'lg:col-span-1' : 'lg:col-span-2'}>
                  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 lg:p-8 h-full">
                    {renderScreenDesktop()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ProcurationProvider>
      </LayoutApp>
    } />
  );
};

export default IndexProcuration;
